import { LineItem } from "src/types/ctgraphql.d";

export const cartCountHelper = (lineItems?: LineItem[]): number =>
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  lineItems ? lineItems.reduce((sum, item) => sum + item.quantity, 0) || 0 : 0;
